import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import {userLogout,forbiddenAccess} from  './auth';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
    .use(function(req) {
        req.on('response', function (res) {
            if (res.status === 401) {
            console.log('UnAuthorized');
              userLogout();
                
            }else if(res.status === 403){
              console.log('Forbidden');
              forbiddenAccess();
            }
        });
});


export function getStaffStart() {
  return {
    type: types.GET_STAFF_START,
  };
}

export function getStaffSuccess({ staff }) {
  return {
    type: types.GET_STAFF_SUCCESS,
    staff,
  };
}

export function setStaffTypes({ types: staffTypes }) {
  return {
    type: types.SET_STAFF_TYPES,
    types: staffTypes,
  };
}

export function getStaffFail(ex) {
  return {
    type: types.GET_STAFF_FAIL,
    error: ex.message,
  };
}

export function getStaffMembers() {
  return (dispatch, getState) => {
    const { business } = getState();
    dispatch(getStaffStart());

    (business.id
      ? Promise.resolve(business.id)
      : request.get(`${window.Config.API_URL}/business/studioId`).withCredentials().set('X-Request-ID', uuidv4())
        .then((resp) => {
          return resp.body.data.id;
        })
    ).then((businessId) => {
      return request.get(`${window.Config.API_URL}/business/dental/staffs`).withCredentials().set('X-Request-ID', uuidv4());
    })
      .then((resp) => {
        dispatch(getStaffSuccess({ staff: resp.body }));
      })
      .catch((ex) => {
        dispatch(getStaffFail(ex));
      });
  };
}

export function getStaffTypes() {
  return (dispatch, getState) => {
    const { business } = getState();

    request.get(`${window.Config.API_URL}/business/dental/staffs/types`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(setStaffTypes({ types: resp.body }));
      })
      .catch((ex) => {
        dispatch(getStaffFail(ex));
      });
  };
}


export function saveStaff(member) {
  return (dispatch, getState) => {
    dispatch(getStaffStart());
    const { staff, business } = getState();

    (member.id
      ? request.put(`${window.Config.API_URL}/business/dental/staffs/${member.id}`).withCredentials().set('X-Request-ID', uuidv4())
        .send(Object.assign(member, {
          emails: member.emails || [],
          phones: member.phones || [],
          name: `${member.first_name} ${member.last_name}`,
          profile_pix: '',
          locations: [],
          service_ids: [],
        }))
        .then(() => {
          const idx = staff.list.findIndex((m) => {
            return m.id === member.id;
          });
          staff.list[idx] = member;
          dispatch(getStaffSuccess({
            staff: staff.list,
          }));
        })
      : request.post(`${window.Config.API_URL}/business/dental/staffs`).withCredentials().set('X-Request-ID', uuidv4())
      .send(Object.assign(member, {
        id: `SC-${business.id}-S-${parseInt(Math.random() * 10000, 10)}`,
        emails: member.emails || [],
        phones: member.phones || [],
        name: `${member.first_name} ${member.last_name}`,
        profile_pix: '',
        locations: [],
        service_ids: [],
      }))
      .then(() => {
        staff.list.push(member);
        dispatch(getStaffSuccess({
          staff: staff.list,
        }));
      }))
      .catch((ex) => {
        dispatch(getStaffFail(ex));
      });
  };
}


export function removeStaff(id) {
  return (dispatch, getState) => {
    dispatch(getStaffStart());
    const { staff, business } = getState();
    const idx = staff.list.findIndex((m) => {
      return m.id === id;
    });
    if (idx !== -1) {
      request.delete(`${window.Config.API_URL}/business/dental/staffs/${id}`).withCredentials().set('X-Request-ID', uuidv4())
        .then(() => {
          staff.list.splice(idx, 1);
          dispatch(getStaffSuccess({
            staff: staff.list,
          }));
        })
        .catch((ex) => {
          dispatch(getStaffFail(ex));
        });
    }
  };
}
